import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { AccessCodeListModel } from 'src/models/accessCodes.models'
import { getCspUser } from 'src/redux/actions/data/users.actions'
import { RootState } from 'src/redux/createRootReducer'
import { selectCspAuthedIssuerIdJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { PostAccessCodeRequest } from 'src/requests/postAccessCode.request'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const POST_ACCESS_CODE_INIT = 'csp/POST_ACCESS_CODE_INIT'
export const POST_ACCESS_CODE_SUCCESS =
  'csp/virtualCards/POST_ACCESS_CODE_SUCCESS'
export const POST_ACCESS_CODE_FAILURE = 'csp/POST_ACCESS_CODE_FAILURE'

export type PostAccessCodeSuccessPayload = {
  accessToken: AccessCodeListModel
}

export type PostAccessCodeFailurePayload = BackendErrorPayload<string>

export interface PostAccessCodeInitAction {
  type: typeof POST_ACCESS_CODE_INIT
}
export interface PostAccessCodeSuccessAction {
  type: typeof POST_ACCESS_CODE_SUCCESS
  payload: PostAccessCodeSuccessPayload
}
export interface PostAccessCodeFailureAction {
  type: typeof POST_ACCESS_CODE_FAILURE
  payload: PostAccessCodeFailurePayload
}

export type PostAccessCodeActions =
  | PostAccessCodeInitAction
  | PostAccessCodeSuccessAction
  | PostAccessCodeFailureAction

const createPostAccessCodeInitAction = (): PostAccessCodeInitAction => ({
  type: POST_ACCESS_CODE_INIT,
})
const createPostAccessCodeSuccessAction = (
  payload: PostAccessCodeSuccessPayload,
): PostAccessCodeSuccessAction => ({
  type: POST_ACCESS_CODE_SUCCESS,
  payload,
})
const createPostAccessCodeFailureAction = (
  payload: PostAccessCodeFailurePayload,
): PostAccessCodeFailureAction => ({
  type: POST_ACCESS_CODE_FAILURE,
  payload,
})

export const postAccessCode = (
  userId: string,
  body: Partial<PostAccessCodeRequest>,
): ThunkAction<Promise<void>, RootState, void, PostAccessCodeActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, PostAccessCodeActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createPostAccessCodeInitAction())
    return axios
      .post<PostAccessCodeSuccessPayload>(
        `/csp/access/create`,
        body,
        selectCspAuthedIssuerIdJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          dispatch(createPostAccessCodeSuccessAction(response.data))
          dispatch(getCspUser(userId))
        },
        (err) => {
          dispatch(createPostAccessCodeFailureAction(err.response.data))
        },
      )
  }
}
